document.addEventListener('DOMContentLoaded', () => {
  // function to add active class to parent element if body has specified class
  function addActiveClassIfBodyHasClass(className, elementId) {
    if (document.body.classList.contains(className)) {
      document.getElementById(elementId).classList.add('active');
    }
  }

  // add active classes to nav items in primary and utility nav
  const navItems = [
    'nfa',
    'nfirs',
    'prevention',
    'statistics',
    'ems',
    'wui',
    'a-z',
    'search',
    'hotel',
    'library',
    'publications',
    'blog',
    'image-gallery',
    'podcasts',
    'about',
    'contact',
  ];
  navItems.forEach((itemId) => {
    addActiveClassIfBodyHasClass(itemId, itemId);
  });
});

// Add active state for secondary/tertiary navs (legacy)
const url = window.location;
const secondaryNavLinks = document.querySelectorAll('#additionalNav li a');
secondaryNavLinks.forEach((link) => {
  if (link.href == url) {
    link.setAttribute('aria-current', 'page');
    link.classList.add('active');
  }
});

// Add active state for secondary/tertiary navs
// const url = window.location;
const tagList = document.querySelectorAll('#tagList li a');
tagList.forEach((link) => {
  if (link.href == url) {
    link.setAttribute('aria-current', 'page');
    link.classList.add('active');
  }
});

